import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconVideo$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVideo extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '45bf49ef1f88c36790ff0318fde1fd4dc1254a24', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f617f28ea94f57b93db25ad5eab233e1149fbdee', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7eff8e3edb1740611849687d3d03165d1e2341bf', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5zm16 1.5v11h-15v-11zM9 13.2V8.51a.3.3 0 0 1 .45-.26l4.41 2.47a.3.3 0 0 1 0 .53l-4.43 2.21A.29.29 0 0 1 9 13.2", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-video", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-video"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-video":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVideo$1);
            }
            break;
    } });
}

const CosmosIconVideo = CosmosIconVideo$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVideo, defineCustomElement };
